import React, {Component} from 'react';
import {
  StyleSheet,
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Platform,
  Alert,
  Dimensions
} from 'react-native';
import colors from '../../HelperClasses/AppColor';
import appConfigStyle from '../../StyleSheets/AppConfigStyleSheet';
import PropTypes from 'prop-types';
import tableStyle from '../../StyleSheets/TableCommonStyleSheet';
import networkService from '../../Network/NetworkManager';
import Appload from '../../HelperClasses/AppLoaderClasses/AppLoader';

import {AppToast} from '../../HelperClasses/AppToast';
import { addMixpanelEvent, MixpanelEvent } from '../../Models/MixPannelEnum';
import {clearCommunicationDraft, readCommunicationDraft, writeCommunicationDraft} from '../../Localization/communicationDrafts';

const AppConstants = require('../../Constants/AppConstants');

const APPURL = require('../../Constants/URLConstants');
let KeyGroup = 'orders';

const feedbackTypeArray = ['Email', 'Phone', 'Email or Phone']
const windowWidth = Dimensions.get('window').width;
let fixedWidth = AppConstants.mobileMaxWidth;;

let itsMobileView = windowWidth < fixedWidth  ?  true : false


export default class OrderNotification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updateUI: false,
      dataLoad: false,
      valueArray: readCommunicationDraft('orderNotification').valueArray || Array(17).fill(''),
      expandedCompactGroups: [],
    };
    this.saveButtonAction = this.saveButtonAction.bind(this);
  }
  static propTypes = {
    backBtn: PropTypes.func,
    compact: PropTypes.bool,
    saveBtnCB: PropTypes.bool,
  };
  componentDidMount() {
    this.loadConfigApi();
  }

  //MARK:-  APIs Method 
  loadConfigApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config + `?key_group=${KeyGroup}`, 'get', '', '',
    );
    this.setState({currencyArray: []});
    if (responseJson['status'] == true) {
      var configs = responseJson['data']['configs'];
      console.log('this.state.configs =>', configs);
      const draftValues = readCommunicationDraft('orderNotification').valueArray || [];
      this.state.valueArray = keysArray.map((key, index) => draftValues[index] ?? configs[key] ?? defaultValue[index]);
    }
    this.setState({dataLoad: true});
  };
 
  addOrUpdateAppDetailApi = async () => {
    var configs = [];
    let values = this.state.valueArray;
    let keys = keysArray
    for (let a = 0; a < keys.length; a++) {
      if (values[a].length != 0){
        let fDict = {
          key_group: KeyGroup,
          key: keys[a],
          value: values[a],
          secured: false,
        };
        configs.push(fDict);
      }
    }
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config,  'post',  JSON.stringify({configs: configs}));
    this.setState({dataLoad: true});
    if (responseJson['status'] == true) {
      clearCommunicationDraft('orderNotification');
      addMixpanelEvent(MixpanelEvent.orderStatusNotification,{'success':true})
      this.setState({dataLoad: true})
      this.alertView('Uploaded successfully')
    } else {
      addMixpanelEvent(MixpanelEvent.orderStatusNotification,{'success':false})
      this.alertView(responseJson)
    }
  };
  alertView(title) {
    if (Platform.OS === 'web') {
      AppToast();
    } else {
      Alert.alert(title);
    }
  }
  //MARK:-  Buttons Action Method 
  saveButtonAction() {
    this.setState({dataLoad: false});
    return this.addOrUpdateAppDetailApi();
  }
  onChangeTextValue(id,text) {
    this.state.valueArray[id] = text
    writeCommunicationDraft('orderNotification', {valueArray: this.state.valueArray});
    this.setState({updateUI: this.state.updateUI});
  };

  toggleCompactGroup = groupId => {
    this.setState(prevState => ({
      expandedCompactGroups: prevState.expandedCompactGroups.includes(groupId)
        ? prevState.expandedCompactGroups.filter(id => id !== groupId)
        : [...prevState.expandedCompactGroups, groupId],
    }));
  };

  renderCompactOrderStatusView = () => (
    <View style={styles.compactAccordion}>
      {compactOrderGroups.map(group => {
        const isExpanded = this.state.expandedCompactGroups.includes(group.id);
        return (
          <View style={styles.compactGroup} key={group.id}>
            <TouchableOpacity
              style={styles.compactGroupHeader}
              onPress={() => this.toggleCompactGroup(group.id)}>
              <View>
                <Text style={styles.compactGroupTitle}>{this.translate(`communications.order_group_${group.id}`, group.title)}</Text>
                <Text style={styles.compactGroupDescription}>
                  {this.translate('communications.notification_settings_count', '{count} notification settings').replace('{count}', String(group.items.length))}
                </Text>
              </View>
              <Text style={styles.compactChevron}>{isExpanded ? '−' : '+'}</Text>
            </TouchableOpacity>
            {isExpanded &&
              group.items.map(item => (
                <View style={styles.compactRow} key={item.index}>
                  <Text style={styles.compactRowLabel}>{this.translate(`communications.order_field_${item.index}`, item.title)}</Text>
                  <TextInput
                    style={styles.compactRowInput}
                    value={this.state.valueArray[item.index]}
                    onChangeText={text =>
                      this.onChangeTextValue(item.index, text)
                    }
                  />
                </View>
              ))}
          </View>
        );
      })}
    </View>
  );
  //MARK:-  UIs 
  renderOrderStatusBackView = () => {
    var view = [];
    for (let a = 0; a < titleArray.length; a++) {
      let obj = this.translate(`communications.order_field_${a}`, titleArray[a]);
      let placeholder = this.translate('communications.enter_order_field', 'Enter {field}').replace('{field}', obj);
      view.push(<View style={this.props.compact ? styles.compactField : { marginTop: 30, zIndex: a+1 }}>
        <Text style={this.props.compact ? styles.compactLabel : appConfigStyle.titleTxtStyle}>{obj}</Text>
        <TextInput
          style={[appConfigStyle.txtFieldStyle, this.props.compact && styles.compactInput, {outlineWidth:0}]}
          placeholder={placeholder}
          placeholderTextColor={colors.placeholderColor}
          onChangeText={txt => this.onChangeTextValue(a,txt)}
          value={this.state.valueArray[a]}
        />
      </View>)
    }
    return (<View style={this.props.compact ? styles.compactGrid : undefined}>
      {view}
    </View>
    )
  }
  render() {
    return (
      <View
        style={
          this.props.compact
            ? styles.compactContainer
            : {
                width: itsMobileView ? '95%' : '70%',
                marginBottom: 50,
                marginLeft: 10,
              }
        }>
        {!this.props.compact && (
          <Text style={tableStyle.listTitleText}>{this.translate('communications.order_status_notification', 'Order Status Notification')}</Text>
        )}
        {!this.props.compact && (
          <Text style={appConfigStyle.subTitleStyle}>
            {this.translate('communications.realtime_config_notice', AppConstants.plainTextString)}
          </Text>
        )}
        {!this.props.compact && (
          <View style={appConfigStyle.horizontalLineViewStyle} />
        )}
        <View style={appConfigStyle.subViewStyle}>
          <View style={{flexDirection: 'column', flex: 1.5}}>
            <View style={{marginTop: this.props.compact ? 0 : -40}}>
              {this.props.compact ? (
                <this.renderCompactOrderStatusView />
              ) : (
                <this.renderOrderStatusBackView />
              )}
            </View>
          </View>
        </View>
        {!this.props.compact && <Appload enable={this.state.dataLoad} />}
      </View>
    );
  }
  translate = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
}
const styles = StyleSheet.create({
  Container: {
    flex: 1,
    backgroundColor: 'white',
  },
  compactContainer: {
    width: '100%',
    marginBottom: 10,
    marginLeft: 0,
  },
  compactGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
  },
  compactField: {
    width: itsMobileView ? '100%' : '50%',
    marginTop: 8,
    paddingRight: 8,
  },
  compactLabel: {
    color: 'var(--color-text-secondary)',
    fontSize: 13,
    marginBottom: 4,
  },
  compactInput: {
    height: 42,
    minHeight: 42,
    fontSize: 14,
    paddingVertical: 6,
  },
  compactAccordion: {
    width: '100%',
  },
  compactGroup: {
    borderColor: '#dce3ec',
    borderWidth: 1,
    borderRadius: 8,
    marginBottom: 10,
    overflow: 'hidden',
    backgroundColor: 'white',
  },
  compactGroupHeader: {
    minHeight: 58,
    paddingHorizontal: 14,
    paddingVertical: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#f7f9fb',
  },
  compactGroupTitle: {
    color: colors.AppNewGreen,
    fontSize: 15,
    fontWeight: '600',
  },
  compactGroupDescription: {
    color: 'var(--color-text-secondary)',
    fontSize: 12,
    marginTop: 3,
  },
  compactChevron: {
    color: colors.AppNewGreen,
    fontSize: 24,
    fontWeight: '300',
  },
  compactRow: {
    padding: 12,
    borderTopColor: '#e7ebf0',
    borderTopWidth: 1,
  },
  compactRowLabel: {
    color: 'var(--color-text-secondary)',
    fontSize: 13,
    marginBottom: 6,
  },
  compactRowInput: {
    borderColor: '#9aa5b5',
    borderWidth: 1,
    borderRadius: 6,
    height: 38,
    paddingHorizontal: 10,
    fontSize: 14,
    outlineWidth: 0,
  },
});

const titleArray = [
  'Order status confirmed',
  'Order status in progress',
  'Order status shipped',
  'Order status customer unreachable',
  'Order status out for delivery',
  'Order status undelivered returned',
  'Order status undelivered return confirmed',
  'Order status delivered',
  'Order status delivered confirmed',
  'Order status customer return initiated',
  'Order status customer return picked',
  'Order status customer return confirmed',
  'Order status customer return disputed',
  'Order status cancelled by account',
  'Order status cancelled by customer',
  'Order status ready for pickup',
  'Order status completed',
];
const compactOrderGroups = [
  {
    id: 'lifecycle',
    title: 'Order lifecycle',
    items: [0, 1, 2, 4, 7, 16].map(index => ({
      index,
      title: titleArray[index],
    })),
  },
  {
    id: 'returns',
    title: 'Returns and delivery issues',
    items: [3, 5, 6, 8, 9, 10, 11, 12].map(index => ({
      index,
      title: titleArray[index],
    })),
  },
  {
    id: 'cancellations',
    title: 'Cancellations and pickup',
    items: [13, 14, 15].map(index => ({
      index,
      title: titleArray[index],
    })),
  },
];
const keysArray = [
  'order_status_confirmed',
  'order_status_in_progress',
  'order_status_shipped',
  'order_status_customer_unreachable',
  'order_status_out_for_delivery',
  'order_status_undelivered_returned',
  'order_status_undelivered_return_confirmed',
  'order_status_delivered',
  'order_status_delivered_confirmed',
  'order_status_customer_return_initiated',
  'order_status_customer_return_picked',
  'order_status_customer_return_confirmed',
  'order_status_customer_return_disputed',
  'order_status_cancelled_by_account',
  'order_status_cancelled_by_customer',
  'order_status_ready_for_pickup',
  'order_status_completed',
] 

const defaultValue = [
  'Confirmed',
  'In Progress',
  'Shipped',
  'Customer Unreachable',
  'Out For Delivery',
  'Undelivered Returned',
  'Undelivered Return Confirmed',
  'Delivered',
  'Delivery Confirmed',
  'Return Initiated',
  'Return Picked',
  'Return Confirmed',
  'Return Disputed',
  'Cancelled by seller',
  'Cancelled by customer',
  'Ready for pickup',
  'Completed',
]
